import { ComponentType } from "react";
import { twMerge } from "tailwind-merge";

export interface ThemeProps {
  className?: string;
  color?: "primary" | "secondary" | "secondary2" | "tertiary" | "quaternary" | "quinary";
  size?: "xl" | "md";
}
type Keys = Exclude<ThemeProps["color"] | ThemeProps["size"], undefined>;
export type ThemeClassNames = Partial<Record<Keys, string>>;
export const withTheme = <P extends object>(
  Component: ComponentType<P>,
  classNames: ThemeClassNames
) => {
  return ({
    color = "primary",
    size = "md",
    className,
    ...props
  }: ThemeProps & P) => {
    const themeClassName = [color, size]
      .filter(Boolean)
      .map((key) => classNames[key])
      .join(" ");
    return (
      <Component
        className={twMerge(themeClassName, className)}
        {...(props as P)}
      />
    );
  };
};
